import { render } from "./collection-billing-tickets.vue?vue&type=template&id=cf76222c&scoped=true"
import script from "./collection-billing-tickets.vue?vue&type=script&lang=js"
export * from "./collection-billing-tickets.vue?vue&type=script&lang=js"

import "./collection-billing-tickets.vue?vue&type=style&index=0&id=cf76222c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf76222c"]])

export default __exports__